import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "data/categories/actions";
import RaisedButton from "material-ui/RaisedButton";
import { Page, PageSection, PageBlock, RightDrawer } from "components/Page";

import Subheader from "material-ui/Subheader";
import Row from "components/Form/Row";
import MenuLink from "components/Navigation/MenuLink";
import ImageField from "components/Form/ImageField";

import Field from "components/Form/Field";
import DropdownField from "components/Form/DropdownField";

class Category extends Component {
  state = {};

  static contextTypes = {
    router: PropTypes.object
  };

  handleCancel(id) {
    this.context.router.history.push("/admin/categories");
  }

  componentWillMount() {
    this.props.fetchCategory(this.props.params.id);
    this.props.fetchCategories();
  }

  handleFormSubmit(event) {
    var data = _.map(this.refs, (r, i) => {
      return { [i]: r.state.value || "" };
    });
    let merged = Object.assign(...data);
    merged.iconUrl = this.refs.icon.state.url || "";
    merged.themeimageUrl = this.refs.themeimage.state.url || "";
    merged.bgthemeimageUrl = this.refs.bgthemeimage.state.url || "";

    this.props.updateCategory(this.props.params.id, merged);
  }

  render() {
    return [
      <RightDrawer key="right">
        <PageBlock label="Kanaler" />
      </RightDrawer>,
      <Page key="page" ready={!this.props.pending}>
        <div
          onSubmit={this.handleFormSubmit.bind(this)}
          className="form-inline"
        >
          <PageSection label="Översikt">
            <Row>
              <DropdownField
                ref="parentid"
                value={this.props.category.parentid}
                label="Huvudkanal"
                options={this.props.categories}
                clear=" - Rensa"
              />
            </Row>
            <Row>
              <Field
                ref="name"
                value={this.props.category.name}
                floatingLabelText="Kanal / namn"
              />
            </Row>
            <Row>
              <Field
                ref="subtitle"
                value={this.props.category.subtitle}
                floatingLabelText="Underrubrik"
              />
            </Row>
            <Row>
              <Field
                ref="description"
                value={this.props.category.description}
                floatingLabelText="Beskrivning"
                multiLine={true}
              />
            </Row>
            <Row>
              <Field floatingLabelText="Färg" />
            </Row>
          </PageSection>
          <PageSection label="Bilder">
            <Row styleName="padded">
              <ImageField
                ref="icon"
                value={this.props.category.icon}
                url={this.props.category.iconUrl}
                label="Ikon, png 60 x 60"
              />
            </Row>
            <Row styleName="padded">
              <ImageField
                ref="themeimage"
                value={this.props.category.themeimage}
                url={this.props.category.themeimageUrl}
                label="Temebild, jpg 300 x 150"
              />
            </Row>
            <Row styleName="padded">
              <ImageField
                ref="bgthemeimage"
                value={this.props.category.bgthemeimage}
                url={this.props.category.bgthemeimageUrl}
                label="Temebild, jpg 1500 x 240"
              />
            </Row>
            <Row styleName="padded">
              <RaisedButton
                onTouchTap={this.handleFormSubmit.bind(this)}
                primary={true}
                label="Spara"
              />
              <RaisedButton
                onTouchTap={this.handleCancel.bind(this)}
                label="Stäng"
              />
            </Row>
          </PageSection>
        </div>
      </Page>
    ];
  }
}

function mapStateToProps(state, ownProps) {
  var selectparents = _.pickBy(
    state.categories.list.data,
    o => !o.parentid && o.parentid !== ownProps.params.id
  );
  return {
    category: state.categories.details.data,
    pending: state.categories.details.pending,
    categories: selectparents
  };
}

export default connect(mapStateToProps, actions)(Category);



// WEBPACK FOOTER //
// ./src/pages/admin/categories/Category.jsx